import { Component } from '@angular/core';

@Component({
  selector: 'locker-cart-add-icon',
  standalone: true,
  imports: [],
  templateUrl: './locker-cart-add.component.html',
  styleUrls: ['./locker-cart-add.component.scss'],
})
export class LockerCartAddIcon{
}
